import Form, { FormProps } from "../../../ui-components/forms/form/Form";
import { EditProfileProps } from "./EditProfileForm";

export const TypedForm: (props: FormProps<EditProfileProps>) => JSX.Element =
  props => Form<EditProfileProps>(props);
